import { createAction } from '@reduxjs/toolkit';
import { createActionName, toThunk } from './helpers';
import {
	TenantStackCreateRequest as TSCrReq,
	TenantStackCheckRequest as TSCkReq,
	TenantStackCheckResponse as TSCRes,
} from '@Types/tenatStack';

const CTX = 'tenantStack';
const CHECK = 'check';
const POLL = 'poll';

// ? Action names
const CREATE_STACK = createActionName(CTX, 'create');
const CHECK_STACK_POLL = createActionName(CTX, CHECK, POLL);
const CHECK_STACK_POLL_STOP = createActionName(CHECK_STACK_POLL, 'stop');
const CHECK_STACK_POLL_TOUT = createActionName(CHECK_STACK_POLL, 'tout');
// ? Thunks
const C_THUNK = toThunk(CREATE_STACK);
const CSP_THUNK = toThunk(CHECK_STACK_POLL);

// * Actions create tenant stack
export const tenantStackCreate = createAction<TSCrReq>(C_THUNK.action);
export const tenantStackCreateResolved = createAction(C_THUNK.resolved);
export const tenantStackCreateRejected = createAction(C_THUNK.rejected);

// * Actions check tenant stack existence polling
export const tenantStackCheckPoll = createAction<TSCkReq>(CSP_THUNK.action);
export const tenantStackCheckPollResolved = createAction<TSCRes>(
	CSP_THUNK.resolved,
);
export const tenantStackCheckPollRejected = createAction(CSP_THUNK.rejected);
export const tenantStackCheckPollStop = createAction(CHECK_STACK_POLL_STOP);
export const tenantStackCheckPollTimeout = createAction(CHECK_STACK_POLL_TOUT);
